import { useAnalytics } from '../components/AnalyticsProvider';
import type { LogLevel } from './logLevel';

export function useClientLogger() {
  const { logMessage, logError } = useAnalytics();
  return {
    log(level: LogLevel, message: string, data?: Record<string, unknown>): void {
      logMessage(level, message, data);
    },
    logError(message: string, error: Error, data?: Record<string, unknown>): void {
      logError(message, error, data);
    },
  };
}
